import styles from './index.module.scss'
import MessageList from './message-list'
import { getStores } from '@/stores'
import { observer } from 'mobx-react'
// import React from 'react'
// import { iframePreviewAgentPage } from '@/utils/agent'

const Core = () => {
  const { agentV2Store } = getStores()
  if (!agentV2Store.initMsgListData) {
    return null
  }

  return (
    <div className={styles.container}>
      <MessageList />
    </div>
  )
}

export default observer(Core)
